(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 45301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(11295);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94934:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nfluence logo4.dadb6493.png","height":57,"width":329,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAACVBMVEUQEBAQEBAQEBBMumWXAAAAA3RSTlN9j10PnpYQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAEUlEQVR4nGNgZGBiYGRkYAAAACQABgaOcWMAAAAASUVORK5CYII="});

/***/ }),

/***/ 11295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js + 1 modules
var chakra_ui_layout_esm = __webpack_require__(23256);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/chakra-ui-hooks.esm.js
var chakra_ui_hooks_esm = __webpack_require__(97375);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/chakra-ui-menu.esm.js + 1 modules
var chakra_ui_menu_esm = __webpack_require__(26788);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/chakra-ui-icon.esm.js + 1 modules
var chakra_ui_icon_esm = __webpack_require__(83703);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 5 modules
var chakra_ui_system_esm = __webpack_require__(11694);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(61100);
// EXTERNAL MODULE: ./public/images/nfluence/nfluence logo4.png
var nfluence_logo4 = __webpack_require__(94934);
;// CONCATENATED MODULE: ./public/images/nfluence/nfluence logo5.png
/* harmony default export */ var nfluence_logo5 = ({"src":"/_next/static/media/nfluence logo5.4cf53ebe.png","height":171,"width":987,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAACVBMVEWBWtaAWtaAWtMvLyx6AAAAA3RSTlN6j10K0YCVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAEUlEQVR4nGNgZGBiYGRkYAAAACQABgaOcWMAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var index_esm = __webpack_require__(63750);
// EXTERNAL MODULE: ./node_modules/react-reveal/Pulse.js
var Pulse = __webpack_require__(19539);
var Pulse_default = /*#__PURE__*/__webpack_require__.n(Pulse);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 152 modules
var motion = __webpack_require__(53272);
// EXTERNAL MODULE: ./node_modules/react-reveal/Fade.js
var Fade = __webpack_require__(19470);
var Fade_default = /*#__PURE__*/__webpack_require__.n(Fade);
;// CONCATENATED MODULE: ./pages/index.tsx



// Redux Imports

//Asset Imports


//NextJS Imports



// Icon Imports


// External Library Imports


var MotionBox = (0,motion/* motion */.E)(chakra_ui_layout_esm/* Box */.xu);
var BorderBox = function(param) {
    var canHover = param.canHover, mr = param.mr;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        d: "inline-flex",
        minW: [
            "80px",
            "150px",
            "150px",
            "150px",
            "250px"
        ],
        height: "auto",
        borderBottom: "3px solid #333",
        transitionDuration: "1s",
        mr: mr,
        ml: "1.2vw"
    }));
};
var Home = function() {
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var content = [
        {
            text: [],
            image: "landing_bg.png"
        },
        {
            text: [
                "Creators",
                "brands",
                "middleman"
            ],
            image: "NFLUENCE_LandingPage.png"
        },
        {
            text: [
                "Brands",
                "influencers",
                "labor to manage campaigns"
            ],
            image: "landing_brandsbg.png"
        },
        {
            text: [
                "People",
                "People",
                "little details"
            ],
            image: "landing_bg.png"
        }, 
    ];
    var ref = (0,chakra_ui_hooks_esm/* useDisclosure */.qY)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var ref1 = (0,react.useState)(0), currIndex = ref1[0], setCurrIndex = ref1[1];
    var ref2 = (0,react.useState)(false), hasOpened = ref2[0], setHasOpened = ref2[1];
    var ref3 = (0,react.useState)(false), isHover = ref3[0], setIsHover = ref3[1];
    var ref4 = (0,react.useState)(60000), newInterval = ref4[0], setNewInterval = ref4[1];
    var checkRedirect = function() {
        if (currIndex === 0) {
            setCurrIndex(3);
            onClose();
            setNewInterval(30000);
        }
        if (currIndex == 3) {
        // router.push("/creators");
        }
    };
    (0,react.useEffect)(function() {
        if (hasOpened == false) {
            setTimeout(function() {
                onOpen();
                setHasOpened(true);
            }, 5000);
        }
    });
    (0,react.useEffect)(function() {
        // setTimeout(() => {
        //   if (currIndex === 0) {
        //     setCurrIndex(3);
        //   }
        // }, 5000);
        // setCurrIndex(3);
        var intervalID = setInterval(checkRedirect, newInterval); // 15 second shuffle for now
        return function() {
            return clearInterval(intervalID);
        };
    }, [
        checkRedirect
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
        flexDirection: "column",
        justify: "space-between",
        minH: "100vh",
        width: "100%",
        height: "100%",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundImage: "url('./images/nfluence/landing/" + content[currIndex]["image"] + "')",
        zIndex: 1,
        pt: "15px",
        pl: [
            "2em",
            "2em",
            "2em",
            "3em"
        ],
        overflowY: "scroll",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                        paddingY: "15px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Link */.rU, {
                            cursor: "pointer",
                            onClick: function() {
                                router.reload();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                position: "relative",
                                maxW: "200px",
                                maxH: "40px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    src: currIndex == 0 || currIndex == 3 ? nfluence_logo5 : nfluence_logo4/* default */.Z
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
                        mt: [
                            "100px",
                            "100px",
                            "100px",
                            "80px",
                            "1em"
                        ],
                        align: "flex-start",
                        fontFamily: "Poppins",
                        fontSize: "clamp(0.9rem, 5vw, 4.5rem);",
                        ml: [
                            "0",
                            "0",
                            "0",
                            "1em"
                        ],
                        color: currIndex == 0 || currIndex == 3 || currIndex === 1 ? "white" : "black",
                        fontWeight: 300,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
                                flexWrap: "wrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        children: "We help"
                                    }),
                                    currIndex !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                        bg: "inherit",
                                        fontFamily: "Poppins",
                                        color: currIndex == 1 ? "creator_green" : "brand_purple2",
                                        fontWeight: "600",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Fade_default()), {
                                            spy: currIndex,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, {
                                                mx: [
                                                    "0",
                                                    "0",
                                                    "0",
                                                    "0.5vw"
                                                ],
                                                children: content[currIndex].text[0]
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_menu_esm/* Menu */.v2, {
                                        isOpen: isOpen,
                                        offset: [
                                            0,
                                            0
                                        ],
                                        closeOnSelect: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_menu_esm/* MenuButton */.j2, {
                                                disabled: currIndex !== 0 ? true : false,
                                                _disabled: {
                                                    _hover: {
                                                        bg: "none",
                                                        cursor: "text"
                                                    }
                                                },
                                                _expanded: {
                                                    bg: "inherit"
                                                },
                                                _active: {
                                                    bg: "inherit"
                                                },
                                                _selected: {
                                                    bg: "inherit"
                                                },
                                                _focus: {
                                                    bg: "inherit"
                                                },
                                                _hover: {
                                                    bg: "inherit"
                                                },
                                                _pressed: {
                                                    bg: "inherit"
                                                },
                                                _visited: {
                                                    bg: "inherit"
                                                },
                                                onMouseEnter: onOpen,
                                                onMouseLeave: onClose,
                                                display: "inline-flex",
                                                minW: [
                                                    "80px",
                                                    "150px",
                                                    "150px",
                                                    "150px",
                                                    "250px"
                                                ],
                                                width: "auto",
                                                height: "auto",
                                                marginLeft: "15px",
                                                marginRight: "15px",
                                                borderBottom: currIndex !== 0 ? "0px" : "3px solid #333",
                                                transitionDuration: "1s",
                                                borderRadius: "0px",
                                                bg: "#111",
                                                fontFamily: "Poppins",
                                                fontSize: "clamp(0.9rem, 5vw, 4.5rem);",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MotionBox, {
                                                    initial: {
                                                        backgroundColor: "#111",
                                                        opacity: 0
                                                    },
                                                    animate: {
                                                        // backgroundColor: "#666",
                                                        opacity: 1
                                                    },
                                                    transition: {
                                                        repeat: Infinity,
                                                        repeatType: "reverse",
                                                        repeatDelay: 0.8,
                                                        duration: 0.8,
                                                        delay: 0.5
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, {
                                                        color: "brand_purple2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                                                            as: index_esm/* BsArrowDownShort */.S9U,
                                                            boxSize: [
                                                                "8vw",
                                                                "4vw"
                                                            ]
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_menu_esm/* MenuList */.qy, {
                                                onMouseEnter: onOpen,
                                                onMouseLeave: onClose,
                                                color: "brand_purple2",
                                                borderColor: "inherit",
                                                border: "0px",
                                                borderRadius: "0px",
                                                fontFamily: "Poppins",
                                                fontSize: "clamp(0.875rem, 5vw, 4.5rem);",
                                                bg: "transparent",
                                                minW: "100%",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_menu_esm/* MenuItem */.sN, {
                                                        onClick: function() {
                                                            onClose();
                                                            setCurrIndex(1);
                                                        },
                                                        _hover: {
                                                            bg: "inherit",
                                                            textDecoration: "underline"
                                                        },
                                                        children: "Creators"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_menu_esm/* MenuItem */.sN, {
                                                        onClick: function() {
                                                            onClose();
                                                            setCurrIndex(2);
                                                        },
                                                        _hover: {
                                                            bg: "inherit",
                                                            textDecoration: "underline"
                                                        },
                                                        children: "Brands"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        children: "work with"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
                                flexWrap: "wrap",
                                pt: currIndex == 0 && isOpen ? [
                                    "25vw",
                                    "20vw",
                                    "20vw",
                                    "20vw",
                                    "11vw"
                                ] : "10px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        children: "amazing"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((Fade_default()), {
                                        clear: true,
                                        spy: currIndex,
                                        children: currIndex == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderBox, {
                                            canHover: false,
                                            mr: "1.2vw"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                            fontWeight: 600,
                                            color: currIndex == 1 ? "creator_green" : "brand_purple2",
                                            // pl="0.5vw"
                                            // pr="0.5vw"
                                            mx: [
                                                "0",
                                                "0",
                                                "0",
                                                "0.5vw"
                                            ],
                                            children: content[currIndex]["text"][1]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        children: "without"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                                flexWrap: "wrap",
                                lineHeight: [
                                    "40px",
                                    "40px",
                                    "75px",
                                    "75px",
                                    "120px"
                                ],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        children: "worrying about the"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((Fade_default()), {
                                        clear: true,
                                        spy: currIndex,
                                        children: [
                                            currIndex == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderBox, {
                                                    canHover: false,
                                                    mr: "3px"
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                                fontWeight: 600,
                                                color: currIndex == 1 ? "creator_green" : "brand_purple2",
                                                ml: "1.2vw",
                                                children: currIndex === 2 ? content[currIndex]["text"][2].substring(0, content[currIndex]["text"][2].indexOf(" ")) : content[currIndex]["text"][2]
                                            }),
                                            currIndex == 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.span */.m$.span, {
                                                fontWeight: 600,
                                                color: "brand_purple2",
                                                children: content[currIndex]["text"][2].substring(content[currIndex]["text"][2].indexOf(" ") + 1)
                                            }) : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.span */.m$.span, {
                                        fontFamily: "Poppins",
                                        children: "."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
                w: "100%",
                justifyContent: "flex-end",
                pr: "2em",
                mb: "3em",
                children: [
                    (currIndex == 0 || currIndex == 3) && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/creators",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.a */.m$.a, {
                            zIndex: 999,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Circle */.Cd, {
                                color: "brand_purple2",
                                border: "1px",
                                borderColor: "#444",
                                mb: "10px",
                                onMouseOver: function() {
                                    setIsHover(true);
                                },
                                onMouseLeave: function() {
                                    setIsHover(false);
                                },
                                p: "1em",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                                    as: index_esm/* BsArrowUpLeft */.$A3,
                                    boxSize: "5vw",
                                    minH: "30px",
                                    minW: "30px",
                                    maxH: "80px",
                                    maxW: "80px"
                                })
                            })
                        })
                    }),
                    currIndex == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)((Pulse_default()), {
                        when: isHover == true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/creators",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.a */.m$.a, {
                                onMouseOver: function() {
                                    setIsHover(true);
                                },
                                onMouseLeave: function() {
                                    setIsHover(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
                                    spacing: "1.5em",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                            fontFamily: "Poppins",
                                            fontSize: "clamp(0.875rem, 4.5vw, 1.5rem);",
                                            letterSpacing: "-1px",
                                            textTransform: "uppercase",
                                            fontWeight: 700,
                                            color: "nfluence_green",
                                            children: "Learn How"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Circle */.Cd, {
                                            bg: "nfluence_green",
                                            p: "0.8em",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                                                as: index_esm/* BsArrowRight */.lzl,
                                                boxSize: "5vw",
                                                minH: "30px",
                                                minW: "30px",
                                                maxH: "80px",
                                                maxW: "80px"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    currIndex == 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)((Pulse_default()), {
                        when: isHover == true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/brands",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.a */.m$.a, {
                                onMouseOver: function() {
                                    setIsHover(true);
                                },
                                onMouseLeave: function() {
                                    setIsHover(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
                                    spacing: "1.5em",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                            fontFamily: "Poppins",
                                            fontSize: "clamp(0.875rem, 4.5vw, 1.5rem);",
                                            letterSpacing: "-1px",
                                            textTransform: "uppercase",
                                            fontWeight: 700,
                                            color: "#000",
                                            children: "Learn How"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Circle */.Cd, {
                                            bg: "nfluence_purple3",
                                            p: "0.8em",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                                                as: index_esm/* BsArrowRight */.lzl,
                                                boxSize: "5vw",
                                                minH: "30px",
                                                minW: "30px",
                                                maxH: "80px",
                                                maxW: "80px"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,3256,5675,3272,7226,9154,6788,684,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(45301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);